import './verticalPresent.scss';
import verticalPresentTpl from './verticalPresent.ejs';
import Event from '../eventBus';

import {Transform, RAF} from 'f.component.util';
// import animate from './animate';

class verticalPresent{
    constructor(presentInfo, clientOptions) {
        this.presentInfo = presentInfo;
        this.clientOptions = clientOptions;

        this.boxDom = null;  // 总容器
        this.containerDom = null; // 礼物容器
        this.btn = null; // 发送按钮

        this.coinDom = null;
        this.userCoin = '0';
        this.oneSecLimit;

        this.width = document.documentElement.clientWidth;
        this.height = document.documentElement.clientHeight;

        this.containerHeight = null;
        this.event = Event;

        this.countdownTimer = {}
        this.sendBtnTime = null;

        this.currentPresentId = null;

        this.userType = 'guest';
        this.init();
    }

    init(presentInfo) {

        if(!presentInfo && !this.presentInfo) {
            console.log('礼物信息错误');
            return;
        }

        presentInfo && (this.presentInfo = presentInfo);

        this.initDom(this.presentInfo);
        this.initEvent();
        this.initCustomEvent();
    }

    initDom(presentInfo) {

        if(!presentInfo.length) {
            console.log('礼物信息格式错误，需要为Array');
            return;
        }

        this.boxDom = $(this.renderVerticalPresentTpl());
        this.containerDom = this.boxDom.find('.container');
        this.barDom = this.boxDom.find('.bar');
        this.btnDom = this.boxDom.find('.btn');
        this.coinDom = this.boxDom.find('.num');

        $('body').append(this.boxDom);

        var _this = this;

        this.barDom.on('touchend', '.money', function() {
            if (_this.userType == 'guest' || typeof(_this.clientOptions.guid) == 'undefined') {
                _this.event.trigger('present-login');
                return false;
            } else {
                var param = {
                    guid: _this.clientOptions.guid,
                    token: _this.clientOptions.token,
                    deviceid: _this.clientOptions.deviceid_real,
                    os: _this.clientOptions.os,
                }
                var paramStr = '?os=' + _this.clientOptions.os;
                Object.keys(param).forEach(function(key, index){
                    paramStr += '&' + key + '=' + param[key];
                });
                window.ground.dispatch("web", "https://user.iclient.ifeng.com/user_tasks/credit" + paramStr); // 跳转金币任务页
            }
        });

        this.containerHeight = this.containerDom.height();

        Transform(this.containerDom[0]);
        Transform(this.btnDom[0]);

    }

    renderVerticalPresentTpl() {
        return this.renderVerticalPresent(this.formatPresentInfo(this.presentInfo, this.userCoin));
    }

    formatPresentInfo(presentInfo, userCoin) {
        return {data:presentInfo, coin: userCoin};
    }

    initEvent(presentInfo) {
        // this.bindEnterEvent();
        this.bindLeaveEvent();
        this.bindBtnEvent();
        this.bindSelectPresentEvent();
        this.initCountdownPresent();
    }

    bindSelectPresentEvent() {
        var _this = this;
        this.containerDom.on('touchend', '.item', function() {

            let _id = $(this).data('id');
            let _present = _this.presentInfo.filter((_p) => {
                return _p.id == _id;
            })

            if(_this.userType == 'guest' || typeof(_this.clientOptions.guid) == 'undefined') {
                if(_present[0].type != 'countdown') {
                    _this.currentPresentId = _id;
                    $(this).siblings().find('.item-icon').removeClass('select');
                    $(this).find('.item-icon').addClass('select');
                } else if(_present[0].type == 'countdown'){
                    if($(this).find('.item-info span').text() == 0) {
                        _this.currentPresentId = _id;
                        $(this).siblings().find('.item-icon').removeClass('select');
                        $(this).find('.item-icon').addClass('select');
                    } else {
                        _this.currentPresentId = null;
                        $(this).siblings().find('.item-icon').removeClass('select');
                    }
                }
                _this.btnDom.removeClass('forbid');
                return false;
            }

            if(!_present.length) {
                return false;
            } else {
                if(_present[0].type != 'countdown') {
                    _this.currentPresentId = _id;
                    $(this).siblings().find('.item-icon').removeClass('select');
                    $(this).find('.item-icon').addClass('select');

                    if(_present[0].price <= _this.userCoin) {
                        _this.btnDom.removeClass('forbid');
                    } else {
                        _this.btnDom.addClass('forbid');
                    }
                } else if(_present[0].type == 'countdown'){
                    if($(this).find('.item-info span').text() == 0) {
                        _this.currentPresentId = _id;
                        $(this).siblings().find('.item-icon').removeClass('select');
                        $(this).find('.item-icon').addClass('select');
                        _this.btnDom.removeClass('forbid');
                    } else {
                        _this.currentPresentId = null;
                        $(this).siblings().find('.item-icon').removeClass('select');
                        _this.btnDom.addClass('forbid');
                    }
                }
            }

            return false;
        });
        
    }

    bindBtnEvent() {
        this.btnDom.on('touchstart', this.btnAnimateStart.bind(this));
        this.btnDom.on('touchmove', this.btnAnimateStart.bind(this));
        this.btnDom.on('touchend', this.sendPresentInfo.bind(this));
    }

    bindLeaveEvent() {
        this.containerDom.on('touchend', () => false);
        // this.barDom.on('touchend', () => false);
        this.boxDom.on('touchend', this.leave.bind(this));
    }

    initCustomEvent() {
        this.event.on('isLogin', this.login.bind(this));
        this.event.on('present-user-balance', this.updateUserCoin.bind(this));
        this.event.on('countdown', this.countdownStart.bind(this));
    }

    login(type) {
        console.log(type)
        if(type == 'user') {
            this.userType = 'user';
            this.btnDom.addClass('forbid');
        } else if(type == 'guest') {
            this.userType = 'guest';
            this.btnDom.removeClass('forbid');
        }
    }

    initCountdownPresent() {
        this.presentInfo
            .filter((_p) => {
                return _p.type == 'countdown';
            })
            .forEach((_p) => {
                this.countdownStart(_p.id);
            })
    }

    formatCoin(value){
        return (value+'').split('.')[0];
    }
    updateCoin(value){
        this.userCoin = this.formatCoin(value);
        this.coinDom && this.coinDom.text(this.userCoin);
    }
    updateUserCoin(obj) {
        let _balance = obj.balance;
        this.userCoin = this.formatCoin(_balance.sliver);
        this.coinDom.text(this.userCoin);
    }

    // 处理送礼物1s延迟
    handleOneSecLimit() {
        this.oneSecLimit = true;
        this.btnDom.addClass('forbid');
        setTimeout(() => {
            this.btnDom.removeClass('forbid');
            this.oneSecLimit = false;
        }, 1000);
    }

    sendPresentInfo() {
        if(this.userType == 'guest' || typeof(this.clientOptions.guid) == 'undefined') {
            this.btnAnimateEnd();
            this.event.trigger('present-login');
            return false;
        }

        let _present = this.presentInfo
            .filter((_p) => {
                return _p.id == this.currentPresentId;
            })
        if(_present.length) {
            if(this.sendBtnTime) {
                this.sendBtnTime = Date.now();
            } else if(Date.now() - this.sendBtnTime > 500) {
                this.btnAnimateEnd();
            }
            if(_present[0].type == 'countdown') {
                // console.log(`sendCountdown`)
                this.containerDom.find('.item-icon').removeClass('select');
                this.btnDom.removeClass('forbid');
                this.event.trigger('countdown', this.currentPresentId);
                this.event.trigger('send-present', {id:this.currentPresentId, count:1});
                this.currentPresentId = null;
                this.btnAnimateEnd();
            } else {
                if(this.btnDom.hasClass('forbid') || this.oneSecLimit) {
                    return false;
                }
                if(this.userCoin === '0') {
                    this.btnDom.addClass('forbid');
                    return false;
                }
                this.event.trigger('send-present', {id:this.currentPresentId, count:1});
                
                this.handleOneSecLimit();
            }
        }

        return false;
    }

    btnAnimateStart() {
        if(this.btnDom.hasClass('forbid')) {
            return false;
        }
        this.btnDom[0].scaleX = this.btnDom[0].scaleY = 0.8;
    }

    btnAnimateEnd() {
        var __thisbtn = this.btnDom;
        __thisbtn[0].scaleX = this.btnDom[0].scaleY = 1;
        // this.btnDom.animate({scaleX:1,scaleY:1}, 300);
    }

    countdownStart(present_id) {
        let _present = this.presentInfo
            .filter((_p) => {
                return _p.id == present_id;
            })

        if(_present.length && _present[0].type == 'countdown') {
            // console.log(`countdownStart`)
            let _time = _present[0].countdown;
            let _item = this.containerDom.find('[data-id=' + present_id + '] .item-info span');

            clearInterval(this.countdownTimer.present_id);
            this.countdownTimer.present_id = null;

            this.countdownTimer.present_id = setInterval(() => {
                if(_time <= 0) {
                    _item.text('0');
                    clearInterval(this.countdownTimer.present_id);
                }
                _item.text(_time);
                _time--;
            }, 1000)
        }

        return false;
    }

    enter() {
        this.containerDom[0].translateY = this.containerHeight;
        this.boxDom.show();
        this.containerDom.animate({translateY: 0}, 200);
    }

    leave() {
        this.containerDom.animate({translateY: this.containerHeight}, 200, () => {
            // this.containerDom[0].translateY = 0;
            this.boxDom.hide();
        });
    }

    hide() {
        this.boxDom.hide();
    }

    renderVerticalPresent(presentInfo) {
        return verticalPresentTpl(presentInfo);
    }

}

export default verticalPresent;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.gift.mobile/app/lib/verticalPresent/verticalPresent.js